// Note: The first file of a module here, must also register the module

import "./create-campaign.component";
import "./getting-started.component";
import "./recommended-steps.component";
import "./learn-section.component";
import "./support-articles.component";
import "./welcome-steps.component";
import "./setup-selection.component";
import "./verify-dialog.component";
